import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phoneNumber = "32488467522";
  const message = encodeURIComponent(
    `Bonjour Perfect Team Renov 👋

Je visite votre site et je souhaiterais discuter d'un projet de rénovation.

Pouvez-vous me recontacter pour un devis gratuit ?

Merci !`
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-btn"
      className="whatsapp-btn whatsapp-pulse"
      aria-label="Contacter via WhatsApp"
    >
      <MessageCircle size={28} fill="white" />
    </a>
  );
};

export default WhatsAppButton;
